<template lang="html">
    <section class="delivery-address">
        <div v-if="order.isAddressBtnAvailable && order.deliveryAddress" class="bloc-btn-modify">
            <button class="btn btn-modify" @click="showModalDeliveryAddress(dataDeliveryAdress, 'editDeliveryAddress');">
                {{ $t("orders.btnOrders.btnModify") }}
            </button>
        </div>

        <div class="delivery-address-btn" v-if="order.isAddressBtnAvailable && !order.deliveryAddress">
            <button
                v-if="clientHasRights"
                class="btn address-btn btn-client"
                @click="showModalDeliveryAddress(dataDeliveryAdress, 'addDeliveryAddress');"
            >
                {{ $t("orders.deliveryAddress.addDeliveryAddress") }}
            </button>
        </div>

        <div class="delivery-address-content" v-if="order.deliveryAddress">
            <div class="address-content"><p v-html-safe="order.deliveryAddress.content"></p></div>
        </div>
        <Modal :action="dataAction" id="deliveryAddress"></Modal>
    </section>
</template>

<script lang="js">
import {mapGetters} from "vuex"
import Modal from "../modal/Modal"

export default {
    name: 'delivery-address',
    props: ["dataDeliveryAdress"],
    components: {
        Modal
    },
    data() {
        return {
            dataAction: '',
            "deliveryAddress": {
                "id": null,
                "content": ""
            }
        }
    },
    mounted() {
    },
    created() {
    },
    methods: {
        showModalDeliveryAddress(dataDeliveryAdress, action) {
            this.dataAction = {
                action: action,
                data: dataDeliveryAdress
            };
            this.$root.$emit("bv::show::modal", "defaultModal");
        },
    },
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder"
        }),
        clientHasRights() {
            return this.hasClientAccess('orders_manager', ...(this.AccessUser.CONTRIBUTE))
        },
        adminHasRights() {
            return this.hasDiamAccess('orders_manager', ...(this.AccessUser.ADMIN))
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.delivery-address {
    @extend %second-text;
    &-btn {
        text-align: center;
        width: 100%;
    }
    &-content {
        text-align: right;
        .address-content {
            white-space: pre-wrap;
            text-align: left;
        }
    }
}
</style>



// WEBPACK FOOTER //
// delivery-address.vue?5a5f3ab2